<template>
  <NoticeComingSoon v-if="false" />

  <div v-else class="grid grid-cols-4 gap-8">
    <div class="flex flex-col col-span-4 md:col-span-1 gap-8">
      <div class="flex flex-col gap-4">
        <div class="flex gap-4" v-if="navbarMobile">
          <vs-input class="w-full" size="large" placeholder="Que trabajo buscas?" icon-pack="feather" icon="icon-search" icon-no-border v-model="search" />
          <vs-button @click="search">Buscar</vs-button>
        </div>
  
        <div>
          <label>Provincia</label>
          <v-select class="bg-white" :closeOnSelect="true" v-model="province" :options="provinces" :reduce="i => i.value">
          </v-select>
        </div>

        <div>
          <label>Tipo de contrato</label>
          <v-select class="bg-white" :closeOnSelect="true" v-model="tipocontrato" :options="tiposcontrato" :reduce="i => i.value">
          </v-select>
        </div>
        <div>
          <label>Jornada Laboral</label>
          <v-select class="bg-white" :closeOnSelect="true" v-model="jornada" :options="jornadas" :reduce="i => i.value">
          </v-select>
        </div>

        <div class="w-full" v-if="false">
          <label>Rango de Salario Anual</label>
          <vs-slider ticks step="5000" icon="euro" :min="12000" :max="120000" v-model="salario" style="min-width: 100px;"/>
          <small v-if="salario.length">{{ salario[0] }} € - {{ salario[1] }} €</small>
        </div>
      </div>
      <div class="flex justify-end" v-if="navbarMobile">
        <vs-button type="flat">Filtrar</vs-button>
      </div>
    </div>
    <div class="flex flex-col col-span-4 md:col-span-3 gap-8">
      <div class="flex gap-4 mt-6">
        <vs-input class="w-full" placeholder="Palabras Clave" icon-pack="feather" icon="icon-search" icon-no-border v-model="search" />
        <vs-button style="min-width: 105px" @click="fetchJobs">Buscar</vs-button>
      </div>

      <div v-if="jobsCount !== 0">
        {{jobsCount}} ofertas de empleo obtenidas como resultado de la búsqueda.
      </div>
      <div v-else>
        No hay resultados, prueba cambiando los filtros de búsqueda.
      </div>


      <vx-card v-for="(job,i) in jobs" :key="i">
        <div class="flex flex-col gap-6">
          <div>
            <h2 class="mb-2">{{job.titulo | capitalize }}</h2>  
            <p class="text-gray">{{ job.creador | capitalize }}</p>
          </div>
          <div class="flex flex-wrap gap-8 pb-4" style="border-bottom: 1px solid lightgray;">
            
            <span class="flex gap-2 items-center" v-if="(job.salarioMin || job.salarioMax) && (job.salarioMin !== job.salarioMax)">
              <feather-icon icon="DollarSignIcon"/>
              <span v-if="job.salarioMin"> {{ job.salarioMin | formatoJobSalary }} </span>
              <span v-if="job.salarioMin && job.salarioMax"> - </span>
              <span v-if="job.salarioMax"> {{ job.salarioMax | formatoJobSalary }} </span>
              <span v-if="!job.salarioMin && !job.salarioMax"> Sin Especificar </span>
            </span>
            <span class="flex gap-2 items-center" v-if="job.tipoContrato">
              <feather-icon icon="FileTextIcon"/>
              <span v-if="job.tipoContrato === 'Contract'"> Contrato indefinido</span>
              <span v-else-if="job.tipoContrato === 'Temporary'"> Contrato temporal </span>
              <span v-else-if="job.tipoContrato === 'SelfEmployed'"> Autoempleo </span>
              <span v-else> Contrato {{job.tipoContrato | capitalize}} </span>
            </span>
            <span class="flex gap-2 items-center" v-if="job.education">
              <feather-icon icon="BookIcon"/>
              {{job.education | capitalize}}
            </span>
            <span class="flex gap-2 items-center">
              <feather-icon icon="MapPinIcon"/>
              <span v-if="job.ciudadF"> {{ job.ciudadF | capitalize }} </span>
                <span v-if="job.ciudadF && job.provinciaF">-</span>
              <span v-if="job.provinciaF"> {{ job.provinciaF | capitalize }} </span>
                <span v-if="job.provinciaF && job.comunidadF">-</span>
              <span v-if="job.comunidadF"> {{ job.comunidadF | capitalize }} </span>
            </span>
            <span class="flex gap-2 items-center" v-if="job.jornadaF">
              <feather-icon icon="ClockIcon"/>
              Jornada {{job.jornadaF | capitalize}}
            </span>
          </div>
          <div>
            <p v-if="job.contenido"> {{ job.contenido| capitalize }} </p>
            <p v-else-if="job.oferta"> {{ job.oferta | capitalize}} </p>
          </div>
          <div>
            <vs-button icon-pack="feather" icon="icon-check-circle" @click="apply(job)"> Aplicar </vs-button>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="col-span-4 " v-show="jobsCount !== 0">
      <pagination :items="jobsCount" :pageSize="100" :maxPages="7" @changePage="fetchJobs"/>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import Pagination from '../../components/pagination.vue'
import NoticeComingSoon from '../../components/NoticeComingSoon.vue'
export default {
  components: {
    'v-select': vSelect,
    Pagination,
    NoticeComingSoon
  },
  data () {
    return {
      navbarMobile: false,

      search: '',

      province: '0',
      tipocontrato: '0',
      jornada: '0',
      provinces: [
        { value: '0', label: 'Todas'},
        { value:'01', label: 'A Coruña' },
        { value:'02', label: 'Alava' },
        { value:'03', label: 'Albacete' },
        { value:'04', label: 'Alicante' },
        { value:'05', label: 'Almeria' },
        { value:'06', label: 'Asturias' },
        { value:'07', label: 'Avila' },
        { value:'08', label: 'Badajoz' },
        { value:'09', label: 'Barcelona' },
        { value:'10', label: 'Burgos' },
        { value:'11', label: 'Caceres' },
        { value:'12', label: 'Cadiz' },
        { value:'13', label: 'Cantabria' },
        { value:'14', label: 'Castellon' },
        { value:'15', label: 'Ceuta' },
        { value:'16', label: 'Ciudad Real' },
        { value:'17', label: 'Cordoba' },
        { value:'18', label: 'Cuenca' },
        { value:'19', label: 'Girona' },
        { value:'20', label: 'Granada' },
        { value:'21', label: 'Guadalajara' },
        { value:'22', label: 'Guipuzcoa' },
        { value:'23', label: 'Huelva' },
        { value:'24', label: 'Huesca' },
        { value:'25', label: 'Islas Baleares' },
        { value:'26', label: 'Jaen' },
        { value:'27', label: 'La Rioja' },
        { value:'28', label: 'Las Palmas' },
        { value:'29', label: 'Leon' },
        { value:'30', label: 'Lleida' },
        { value:'31', label: 'Lugo' },
        { value:'32', label: 'Madrid' },
        { value:'33', label: 'Malaga' },
        { value:'34', label: 'Melilla' },
        { value:'35', label: 'Murcia' },
        { value:'36', label: 'Navarra' },
        { value:'37', label: 'Ourense' },
        { value:'38', label: 'Palencia' },
        { value:'39', label: 'Pontevedra' },
        { value:'40', label: 'Salamanca' },
        { value:'41', label: 'Segovia' },
        { value:'42', label: 'Sevilla' },
        { value:'43', label: 'Soria' },
        { value:'44', label: 'Santa Cruz de Tenerife' },
        { value:'45', label: 'Tarragona' },
        { value:'46', label: 'Teruel' },
        { value:'47', label: 'Toledo' },
        { value:'48', label: 'Valencia' },
        { value:'49', label: 'Valladolid' },
        { value:'50', label: 'Vizcaya' },
        { value:'51', label: 'Zamora' },
        { value:'52', label: 'Zaragoza' }
      ],
      tiposcontrato: [
        {value:'0', label: 'Todos'},
        {value:'2', label: 'Indefinido'},
        {value:'3', label: 'Temporal'},
        {value:'4', label: 'Auto Empleo'}
      ],
      jornadas: [
        {value:'0', label: 'Todos'},
        {value:'1', label: 'Completa'},
        {value:'2', label: 'Parcial'},
        {value:'3', label: 'Indiferente'},
        {value:'4', label: 'Flexible'}
      ],
      salario: [12000, 120000],

      jobs: [],
      jobsCount: 0,
      currentPage: 0,
      paginationPageSize: 10
    }
  },
  watch: {
    province () {
      this.fetchJobs()
    },
    tipocontrato () {
      this.fetchJobs()
    },
    jornada () {
      this.fetchJobs()
    }
  },
  mounted () {
    this.fetchJobs()
  },
  methods: {
    fetchJobs (pager) {
      // console.log(event)
      this.$vs.loading()
      if (pager && pager.currentPage) {
        this.currentPage = pager.currentPage
        if (pager.currentPage === 1) this.currentPage = 0
      } else {
        this.currentPage = 0
      }

      let query = `https://www.empleate.gob.es/empleate/open/offersearch/selectBuscador?q.op=AND&start=${this.currentPage}&rows=${this.paginationPageSize}`

      if (this.search && this.search !== '' && this.search !== '0') {
        query += `&q=${encodeURIComponent(this.search)}`
      }
      if (this.province && this.province !== '0') {
        query += `&fq=provincia%3A%22${this.province}%22`
      }
      if (this.tipocontrato && this.tipocontrato !== '0') {
        query += `&fq=tipoContratoN%3A%22${this.tipocontrato}%22`
      }
      if (this.jornada && this.jornada !== '0') {
        query += `&fq=jornada%3A%22${this.jornada}%22`
      }

      query += '&sort=score%20desc&json.nl=map&fl=*%2C%20score&q=*&wt=json'

      fetch(query)
        .then(response => response.text())
        .then(text => {
          const jsonText = text.replace(/^jQuery\d+_\d+\(/, '').replace(/\);?$/, '')
          const data = JSON.parse(jsonText)

          this.jobs = data.response.docs
          this.jobsCount = data.response.numFound

          console.log(data)
          this.$vs.loading.close()
        }).catch(error => {
          console.log(error)
          this.$vs.loading.close()

          alert('Estamos enfrentando una interrupción en este servicio debido a un problema con nuestro proveedor. Nuestro equipo está trabajando para crear una alternativa y ofrecerles el mejor servicio posible. Pedimos disculpas y agradecemos su paciencia y comprensión.')
        })
    },
    apply (job) {
      window.open(`https://www.empleate.gob.es/empleo/#/oferta/${job.id}`, '_blank').focus()
    }
  }
}
</script>